import { useEffect, useState } from "react";
import MenuApp from '../../../components/Menu';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import informationService from '../../../services/system';
import AuthService from "../../../services/security/auth.service";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import BusinessCenterOutlined from '@mui/icons-material/BusinessCenterOutlined';
import WorkOutline from '@mui/icons-material/WorkOutline';
import { ArrowUpward, ArrowDownward, ArrowRight } from "@mui/icons-material";
import LockOpen from '@mui/icons-material/LockOpen';
import LockOutline from '@mui/icons-material/Lock';
import WalletOutlined from '@mui/icons-material/WalletOutlined';
import LocalAtmOutlined from '@mui/icons-material/LocalAtmOutlined';
import Sensors from '@mui/icons-material/Sensors';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Doughnut from '../../../components/Doughnut';
import { Card, CardContent, Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import constantsDesign from '../../../utils/constants';
import DateComponent from '../../../components/Date';
import TokenService from "../../../services/security/token.service";
import FooterOperaciones from "../../../components/Footer";
import fix from "../../../services/fix"
import { BlobProvider } from "@react-pdf/renderer";
import VistaPdfExport from "../../../components/Pdf";
import RefreshIcon from '@mui/icons-material/Refresh';
import BarChart from "../../../components/BarChart";

const backgroundColor = [
    "#1E3A8A", // Azul oscuro
    "#065F46", // Verde oscuro
    "#0D9488", // Turquesa oscuro
    "#F97316", // Naranja vibrante
    "#2563EB", // Azul vibrante
    "#047857", // Verde esmeralda
    "#14B8A6", // Turquesa medio
    "#FB923C", // Naranja medio
    "#3B82F6", // Azul claro
    "#059669", // Verde medio
    "#2DD4BF", // Turquesa claro
    "#FCD34D", // Naranja ámbar
    "#60A5FA", // Azul suave
    "#34D399", // Verde claro
    "#5EEAD4", // Turquesa suave
    "#FEF3C7", // Naranja muy claro
    "#93C5FD", // Azul muy claro
    "#6EE7B7", // Verde menta
    "#99F6E4"  // Turquesa muy claro
]

const Performance = () => {
    const user = TokenService.getUser();
    const [performanceReponse, setPerformanceResponse] = useState([]);
    const [entityBalance, setEntityBalance] = useState([]);
    const [entityBalanceUSD, setEntityBalanceUSD] = useState([]);
    const [entityHolding, setEntityHolding] = useState([]);
    const [entityHoldingUSD, setEntityHoldingUSD] = useState([]);
    const [subtotalesCards, setSubtotalesCards] = useState([]);
    const [subtotalesCardsUSD, setSubtotalesCardsUSD] = useState([]);
    const [loadSubtotalesCards, setLoadSubtotalesCards] = useState(false);
    const [expandedItems, setExpandedItems] = useState({});
    const [expandedItemsUSD, setExpandedItemsUSD] = useState({});
    const [totalSubTotal, setSubTotal] = useState(0);
    const [totalSubTotalUSD, setSubTotalUSD] = useState(0);
    const [portafolioDisponible, setPortafolioDisponible] = useState({});
    const [portafolioGarantia, setPortafolioGarantia] = useState({});
    const [portafolioTotal, setPortafolioTotal] = useState({});
    const [portafolioDisponibleUSD, setPortafolioDisponibleUSD] = useState({});
    const [portafolioGarantiaUSD, setPortafolioGarantiaUSD] = useState({});
    const [portafolioTotalUSD, setPortafolioTotalUSD] = useState({});
    const [tipoCambio, setTipoCambio] = useState('');
    const [tipoCambioCcl, setTipoCambioCcl] = useState('');
    const [homeTrade, setHomeTrade] = useState('ars');
    const [filterDate, setFilterDate] = useState(null);
    const [filterDateHasta, setFilterDateHasta] = useState(null);
    const [filterComitente, setFilterComitente] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [optionsComitentes, setOptionsComitentes] = useState([]);
    const [optionsComitentesOriginales, setOptionsComitentesOriginales] = useState([]);
    const [filterManager, setFilterManager] = useState(null);
    const [inputValueManager, setInputValueManager] = useState('');
    const [optionsManager, setOptionsManager] = useState([]);
    const [viewComitente, setViewComitente] = useState(false);
    const [viewManager, setViewManager] = useState(false);
    const [prices, setPrices] = useState([]);

    useEffect(() => {

        const init = async () => {

            document.title = `Home - wBroker`;
            setLoadSubtotalesCards(false);
            searchSourceField();
            let dateNow = formatDate(new Date());
            setFilterDate(dateNow);
            setFilterDateHasta(dateNow);

            loadInfo(dateNow, dateNow, filterComitente, filterManager);

            if (user.data.managerId && user.data.tradeAccountId) {
                setViewComitente(true);
                setViewManager(false);
            } else {
                if (user.data.managerId && !user.data.tradeAccountId) {
                    setViewComitente(true);
                    setViewManager(true);
                } else {
                    if (!user.data.managerId && !user.data.tradeAccountId) {
                        setViewComitente(true);
                        setViewManager(true);
                    }
                }
            }
        }
        init();
        // eslint-disable-next-line
    }, []);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const filterByTradeAccountIdManagerId = (tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];

        if (user.data.companyId) {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: user.data.companyId
            })
        } else {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: null
            })
        }

        if (user.data.tradeAccountId) {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : user.data.tradeAccountId
            })
        } else {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: tradeAccountId !== null ? tradeAccountId.id : null
            })
        }

        if (user.data.managerId) {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : user.data.managerId
            })
        } else {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: managerId !== null ? managerId.id : null
            })
        }


        return whereFieldParam;
    }

    const filterByTradeAccountIdManagerIdFindSourceField = () => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];
        if (user.data.companyId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'companyId') {
                    existe = true;
                    item.value = user.data.companyId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'companyId',
                    operator: '=',
                    value: user.data.companyId
                })
            }
        }

        if (user.data.tradeAccountId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'tradeAccountId') {
                    existe = true;
                    item.value = user.data.tradeAccountId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'tradeAccountId',
                    operator: '=',
                    value: user.data.tradeAccountId
                })
            }
        } else {
            if (user.data.isManager === '1') {
                let existe = false;
                whereFieldParam.forEach((item) => {
                    if (item.idField === 'managerId') {
                        existe = true;
                        item.value = user.data.managerId
                    }
                })
                if (existe === false) {
                    whereFieldParam.push({
                        idField: 'managerId',
                        operator: '=',
                        value: user.data.managerId
                    })
                }
            }
        }
        return whereFieldParam;
    }

    const searchSourceField = () => {
        let whereFilters = filterByTradeAccountIdManagerIdFindSourceField();

        const arrayTables = [{
            table: `${user.data.instance}.tradeAccount`,
            doc: [],
            selectFilters: ['managerId'],
            whereFilters: whereFilters
        }, {
            table: `${user.data.instance}.manager`,
            doc: [],
            selectFilters: [],
            whereFilters: whereFilters
        }]

        informationService.findSourceField(arrayTables).then((response) => {

            let opcComitentes = [];
            let opcManager = [];
            for (let t = 0; t < response.data.length; t++) {
                if (response.data[t].source === 'tradeAccount' && response.data[t].isInactive === '0') {
                    opcComitentes.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                        managerId: response.data[t].managerId
                    })
                }
                if (response.data[t].source === 'manager' && response.data[t].isInactive === '0') {
                    opcManager.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                    })
                }
            }

            let managerId = 0;
            let existeComitente = false;
            let existeAgenteProductor = false;
            if (user.data.isManager === '1') {
                setFilterManager({
                    id: user.data.managerId,
                    label: user.data.manager,
                    isInactive: 0,
                });
                managerId = user.data.managerId;
                existeComitente = true;
            }
            if (user.data.tradeAccountId && user.data.managerId) {
                setFilterComitente({
                    id: user.data.tradeAccountId,
                    label: user.data.tradeAccount,
                    isInactive: 0,
                })
                existeAgenteProductor = true;
            }

            if (managerId > 0) {
                let arrayOptCom = [];
                for (let g = 0; g < opcComitentes.length; g++) {
                    if (Number(opcComitentes[g].managerId) === Number(managerId)) {
                        arrayOptCom.push(opcComitentes[g]);
                    }
                }
                setOptionsComitentes(arrayOptCom);
            } else {
                setOptionsComitentes(opcComitentes);
            }
            setOptionsComitentesOriginales(opcComitentes);
            setOptionsManager(opcManager);

            setLoadSubtotalesCards(true);

        })
    }

    const loadInfo = (fechaDesde, fechaHasta, tradeAccountId, managerId) => {
        const user = AuthService.getCurrentUser();

        let date = fechaDesde.split('-');
        let fechaDesdeFlag = new Date(date[0], Number(date[1]) - 1, date[2]);
        let fechaDesdeParam = formatDate(fechaDesdeFlag);

        date = fechaHasta.split('-');
        let fechaHastaFlag = new Date(date[0], Number(date[1]) - 1, date[2]);
        let fechaHastaParam = formatDate(fechaHastaFlag);

        let where = filterByTradeAccountIdManagerId(tradeAccountId, managerId);

        informationService.storeProcedurePerformance('performance', user.data.instance, fechaDesdeParam, fechaHastaParam, where).then((response) => {

            setPerformanceResponse(response.data.length > 0 ? response.data : []);
            setLoadSubtotalesCards(true);
        }).catch((error) => {
            console.log(error);
        });
    }

    const handleFieldChange = (e) => {
        let value = e.target.value;
        setFilterDate(value);
        setLoadSubtotalesCards(false);

        loadInfo(value, filterDateHasta, filterComitente, filterManager);
    }

    const handleFieldChangeHasta = (e) => {
        let value = e.target.value;
        setFilterDateHasta(value);
        setLoadSubtotalesCards(false);

        loadInfo(filterDate, value, filterComitente, filterManager);
    }

    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);

        const filtered = optionsComitentes.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {
            setFilterComitente(filtered[0]);
            setLoadSubtotalesCards(false);
            loadInfo(filterDate, filterDateHasta, filtered[0], filterManager)

        }
    };

    const handleChange = (event, newValue) => {
        setFilterComitente(newValue);
        setLoadSubtotalesCards(false);
        loadInfo(filterDate, filterDateHasta, newValue, filterManager)

    };

    const handleInputChangeManager = (event, newInputValue) => {
        setInputValueManager(newInputValue);

        const filtered = optionsManager.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        if (filtered.length === 1) {
            setFilterManager(filtered[0]);
            setLoadSubtotalesCards(false);
            let arrayOptCom = [];
            for (let g = 0; g < optionsComitentesOriginales.length; g++) {
                if (optionsComitentesOriginales[g].managerId === filtered[0].id) {
                    arrayOptCom.push(optionsComitentesOriginales[g]);
                }
            }
            setOptionsComitentes(arrayOptCom);
            loadInfo(filterDate, filterDateHasta, filterComitente, filtered[0])

        }
    };

    const handleChangeManager = (event, newValue) => {
        setFilterManager(newValue);
        setLoadSubtotalesCards(false);
        let arrayOptCom = [];
        for (let g = 0; g < optionsComitentesOriginales.length; g++) {
            if (optionsComitentesOriginales[g].managerId === newValue.id) {
                arrayOptCom.push(optionsComitentesOriginales[g]);
            }
        }
        setOptionsComitentes(arrayOptCom);
        loadInfo(filterDate, filterDateHasta, filterComitente, newValue)

    };

    const setViewEntityBalance = (item, mode = "ui") => {

        const isPdf = mode === "pdf";
        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let responseView = [];
        for (let g = 0; g < item.data.length; g++) {

            let amount = 0;
            let cantidad = 0;
            let fieldId = null;
            if (item.name === 'PESOS') {
                amount = Number(item.data[g].amountFx).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountFx';
                cantidad = Number(item.data[g].amount).toFixed(2).toString().replace(/\./g, ',');
            }

            if (item.name === 'USD MEP') {
                amount = Number(item.data[g].amountFxMep).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountFxMep';
                cantidad = Number(item.data[g].amountMep).toFixed(2).toString().replace(/\./g, ',');
            }

            if (item.name === 'USD CABLE') {
                amount = Number(item.data[g].amountFxCcl).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountFxCcl';
                cantidad = Number(item.data[g].amountCcl).toFixed(2).toString().replace(/\./g, ',');
            }

            let valueSplit = amount.split(',');
            if (valueSplit.length > 1) {
                amount = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }
            valueSplit = cantidad.split(',');
            if (valueSplit.length > 1) {
                cantidad = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }


            if (g === 0) {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.name}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{cantidad}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                    </TableRow>
                )
            } else {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }}></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ fontVariantNumeric: 'tabular-nums', minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{cantidad}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>ARS</span>
                                <span>{amount}</span>
                            </div>
                        </TableCell>
                    </TableRow>)
            }
        }
        return responseView;
    }

    const setViewEntityBalanceUSD = (item, mode = "ui") => {

        const isPdf = mode === "pdf";
        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let responseView = [];
        for (let g = 0; g < item.data.length; g++) {

            let amount = 0;
            let amountMepFx = 0;
            let fieldId = null;
            if (item.name === 'PESOS') {
                amount = Number(item.data[g].amount).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amount';
                amountMepFx = Number(item.data[g].amountMepFx).toFixed(2).toString().replace(/\./g, ',');
            }

            if (item.name === 'USD MEP') {
                amount = Number(item.data[g].amountMep).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountMep';
            }

            if (item.name === 'USD CABLE') {
                amount = Number(item.data[g].amountCcl).toFixed(2).toString().replace(/\./g, ',');
                fieldId = 'amountCcl';
            }

            let valueSplit = amount.split(',');
            if (valueSplit.length > 1) {
                amount = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
            }

            if (item.name === 'PESOS') {
                valueSplit = amountMepFx.split(',');
                if (valueSplit.length > 1) {
                    amountMepFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                }
            }

            if (g === 0) {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.name}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{amount}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                            </div></TableCell>
                    </TableRow>
                )
            } else {
                responseView.push(
                    <TableRow sx={getRowStyle(false, g)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }}></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell style={{
                            fontWeight: 'bold',
                            fontSize,
                            padding: cellPadding
                        }}>{item.data[g].status}</TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>{item.name === 'PESOS' ? 'ARS' : 'USD'}</span>
                                <span>{amount}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                            </div></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                            style={{
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: "0.01rem",
                                color: Number(item.data[g][fieldId]) < 0 ? "red" : "black",
                                fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }}
                            align='right'
                        >
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize,
                                gap: isPdf ? "4px" : "8px"
                            }}>
                                <span style={{ minWidth: "30px", textAlign: "left" }}>USD</span>
                                <span>{item.name === 'PESOS' ? amountMepFx : amount}</span>
                            </div></TableCell>
                    </TableRow>)
            }
        }
        return responseView;
    }

    const toggleItem = (itemId) => {
        setExpandedItems(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const toggleItemUSD = (itemId) => {
        setExpandedItemsUSD(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };

    const amountCtaCte = (item) => {
        let amountFx = 0;
        let flagAmount = 0;
        if (item.name === 'PESOS') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountFx);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD MEP') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountFxMep);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD CABLE') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountFxCcl);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        let valueSplit = amountFx.split(',');
        if (valueSplit.length > 1) {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
        } else {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
        }

        return { "number": flagAmount, "text": amountFx }
    }

    const amountCtaCteUSD = (item) => {
        let amountFx = 0;
        let flagAmount = 0;
        if (item.name === 'PESOS') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountMepFx);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD MEP') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountMep);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        if (item.name === 'USD CABLE') {
            for (let j = 0; j < item.data.length; j++) {
                flagAmount += Number(item.data[j].amountCcl);
            }
            amountFx = Number(flagAmount).toFixed(2).toString().replace(/\./g, ',');
        }

        let valueSplit = amountFx.split(',');
        if (valueSplit.length > 1) {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
        } else {
            amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
        }

        return { "number": flagAmount, "text": amountFx }
    }

    const buscarPrecioEnvio = (symbol) => {
        let precioEnVivo = null;
        if (prices) {
            for (let t = 0; t < prices.length; t++) {
                if (prices[t] !== null && prices[t] !== undefined) {
                    if (prices[t].subTabs) {
                        for (let d = 0; d < prices[t].subTabs.length; d++) {
                            for (let e = 0; e < prices[t].subTabs[d].especies.length; e++) {
                                if (symbol === prices[t].subTabs[d].especies[e].Symbol) {

                                    let securityId = prices[t].subTabs[d].especies[e].SecurityID;
                                    let settlType = null;
                                    if (securityId !== null && securityId !== undefined) {
                                        settlType = prices[t].subTabs[d].especies[e].SecurityID.split('-')[1];
                                    }

                                    for (let x = 0; x < prices[t].subTabs[d].especies[e].NoMDEntries.length; x++) {
                                        if (prices[t].subTabs[d].especies[e].NoMDEntries[x].MDEntryType === '0') {

                                            if (prices[t].subTabs[d].especies[e].NoMDEntries[x].priceList !== null) {
                                                if (prices[t].subTabs[d].especies[e].NoMDEntries[x].priceList.length > 0) {
                                                    if (Number(prices[t].subTabs[d].especies[e].NoMDEntries[x].priceList[0].MDEntryPx) > 0) {
                                                        if (precioEnVivo === null) {
                                                            precioEnVivo = {
                                                                precio: Number(prices[t].subTabs[d].especies[e].NoMDEntries[x].priceList[0].MDEntryPx),
                                                                settlType
                                                            }

                                                        } else {

                                                            if (Number(settlType) > Number(precioEnVivo.settlType)) {
                                                                precioEnVivo = {
                                                                    precio: Number(prices[t].subTabs[d].especies[e].NoMDEntries[x].priceList[0].MDEntryPx),
                                                                    settlType
                                                                }

                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return precioEnVivo;;
    }


    const setViewEntitHolding = (entityHolding, mode = "ui") => {
        const isPdf = mode === "pdf";

        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;


        let response = [];
        let subtotalAmount = 0;
        let subtotalCostFx = 0;
        let resultadoTotal = 0;
        let subtotal = null;
        let rowIndex = 0;

        entityHolding.forEach((item, index) => {
            const isItemExpanded = expandedItems[item.itemId];
            const showAll = isItemExpanded || item.status.length === 1;

            item.status
                .filter((_, g) => showAll || g === 0)
                .forEach((_, g) => {
                    //precios en vivo
                    let isPrecioEnVivo = false;
                    let isFactor = '';
                    if (prices.length > 0) {
                        const precioEnVivo = buscarPrecioEnvio(item.symbol);
                        if (item.status[g].factor === null || item.status[g].factor === undefined) {
                            item.status[g].factor = 0;
                            item.status[g].flagIsfactor = true;
                        }
                        if (item.status[g].flagIsfactor === true) {
                            isFactor = '*';
                        }
                        if (precioEnVivo !== null) {
                            if (precioEnVivo.precio !== null && precioEnVivo.precio !== undefined && Number(precioEnVivo.precio) !== 0) {
                                let precioFlag = 0;
                                if (Number(item.status[g].factor) !== 0) {
                                    precioFlag = Number(precioEnVivo.precio) / Number(item.status[g].factor)
                                }
                                item.status[g].fxPrice = precioFlag;
                                item.status[g].amountFx = Number(item.status[g].qty) * Number(precioFlag);
                                item.status[g].profitFx = Number(item.status[g].amountFx) - Number(item.status[g].costFx);
                                //item.status[g].profitPerc = ((Number(item.status[g].profitFx) * 100) / Number(item.status[g].amountFx)).toFixed(2)
                                isPrecioEnVivo = true;
                            }
                        }
                    }
                    //precios en vivo


                    const isFirstRow = g === 0;
                    let amountFx = Number(item.status[g].amountFx).toFixed(2).toString().replace(/\./g, ',');
                    let valueSplit = amountFx.split(',');
                    if (valueSplit.length > 1) {
                        amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        amountFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }

                    let fxPrice = '0,00';
                    if (item.status[g].fxPrice) {
                        fxPrice = Number(item.status[g].fxPrice).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = fxPrice.split(',');
                        if (valueSplit.length > 1) {
                            fxPrice = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            fxPrice = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let qty = '0,00';
                    if (item.status[g].qty) {
                        qty = Number(item.status[g].qty).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = qty.split(',');
                        if (valueSplit.length > 1) {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let costFx = '0,00';
                    if (item.status[g].costFx) {
                        costFx = Number(item.status[g].costFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costFx.split(',');
                        if (valueSplit.length > 1) {
                            costFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let weightPerc = '0,00';
                    if (item.status[g].weightPerc) {
                        weightPerc = Number(item.status[g].weightPerc).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = weightPerc.split(',');
                        if (valueSplit.length > 1) {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }


                    let profitFx = '0,00';
                    if (item.status[g].profitFx) {
                        profitFx = Number(item.status[g].profitFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = profitFx.split(',');
                        if (valueSplit.length > 1) {
                            profitFx = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            profitFx = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    if (item.subtotal !== subtotal && subtotal !== null) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostFxFlag = Number(subtotalCostFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostFxFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalCostFx) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostFxFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                        subtotalAmount = Number(item.status[g].amountFx ? item.status[g].amountFx : 0);
                        subtotalCostFx = Number(item.status[g].costFx ? item.status[g].costFx : 0);
                        resultadoTotal = Number(item.status[g].profitFx ? item.status[g].profitFx : 0);
                    } else {
                        let validate = false;
                        for (let a1 = 0; a1 < item.status.length; a1++) {
                            if (item.status[a1].status === 'Total') {
                                validate = true;
                            }
                        }

                        if (validate === true && item.status[g].status === 'Total') {
                            subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountFx : 0);
                            subtotalCostFx = Number(subtotalCostFx) + Number(item.status[g].costFx ? item.status[g].costFx : 0);
                            resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitFx : 0);


                        } else {
                            if (validate === false && item.status[g].status !== 'Total') {
                                subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountFx : 0);
                                subtotalCostFx = Number(subtotalCostFx) + Number(item.status[g].costFx ? item.status[g].costFx : 0);
                                resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitFx : 0);
                            }
                        }
                    }

                    response.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {isFirstRow && (
                                <Box display="flex" alignItems="center">
                                    <IconButton size="small" onClick={() => toggleItem(item.itemId)}>
                                        {isItemExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                    <span style={{ fontWeight: 'bold' }}>{item.item}</span>
                                </Box>
                            )}
                        </TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}> {isFirstRow && (<>{item.symbol}</>)}</TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>{isFirstRow && (<>{item.isin}</>)}</TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>{item.status[g].status}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].qty) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{qty}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: (isPrecioEnVivo === true ? "#323B98" : (Number(item.status[g].fxPrice) < 0 ? "red" : "black")), fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{fxPrice} {isFactor}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].amountFx) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{amountFx}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costFx) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{costFx}</TableCell>
                        <TableCell style={{
                            letterSpacing: "0.01rem", fontSize,
                            padding: cellPadding
                        }} align="right">
                            {item.status.length === 1 ? (
                                <>
                                    {(Number(item.status[g].profitPerc) * 100).toFixed(2).replace('.', ',')}%

                                    {Number(item.status[g].profitPerc) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitPerc) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : <ArrowRight
                                        style={{ color: "gray", fontSize: "1rem", marginLeft: 4 }}
                                    />}
                                </>
                            ) : item.status.length > 1 && item.status[g].status === "Total" ? (
                                <>
                                    {(Number(item.status[1].profitPerc) * 100).toFixed(2)}%
                                    {Number(item.status[g].profitPerc) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitPerc) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : <ArrowRight
                                        style={{ color: "gray", fontSize: "1rem", marginLeft: 4 }}
                                    />}
                                </>
                            ) : null}
                        </TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].profitFx) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{profitFx}</TableCell>
                    </TableRow>

                    );
                    rowIndex++;
                    subtotal = item.subtotal;

                    if (index === entityHolding.length - 1) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostFxFlag = Number(subtotalCostFx).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostFxFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostFxFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costFx) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostFxFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                    }
                });
        })

        return response;
    };

    const setViewEntitHoldingMEP = (entityHoldingUSD, mode = "ui") => {
        const isPdf = mode === "pdf";

        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let response = [];
        let subtotalAmount = 0;
        let subtotal = null;
        let resultadoTotal = 0;
        let subtotalCostMep = 0;
        let rowIndex = 0;
        entityHoldingUSD.forEach((item, index) => {
            const isItemExpanded = expandedItemsUSD[item.itemId];
            const showAll = isItemExpanded || item.status.length === 1;

            item.status
                .filter((_, g) => showAll || g === 0)
                .forEach((_, g) => {
                    let isPrecioEnVivo = false;
                    let isFactor = '';
                    //precios en vivo
                    if (prices.length > 0) {
                        const precioEnVivo = buscarPrecioEnvio(item.symbol);
                        if (item.status[g].factor === null || item.status[g].factor === undefined) {
                            item.status[g].factor = 0;
                            item.status[g].flagIsfactor = true;
                        }
                        if (item.status[g].flagIsfactor === true) {
                            isFactor = '*';
                        }
                        if (precioEnVivo !== null) {
                            if (precioEnVivo.precio !== null && precioEnVivo.precio !== undefined && Number(precioEnVivo.precio) !== 0) {
                                let tipoCambioFlag = tipoCambio.toString().replaceAll('.', '');
                                tipoCambioFlag = tipoCambioFlag.toString().replaceAll(',', '.');

                                let precioFlag = 0;
                                if (Number(item.status[g].factor) !== 0) {
                                    precioFlag = (Number(precioEnVivo.precio) / Number(item.status[g].factor)) / Number(tipoCambioFlag)
                                }
                                item.status[g].fxPriceUsd = Number(precioFlag);
                                item.status[g].amountUsd = (Number(item.status[g].qty) * Number(precioFlag));
                                item.status[g].profitUsd = (Number(item.status[g].amountFx) - Number(item.status[g].costUsd));
                                isPrecioEnVivo = true;

                                //item.status[g].profitUsdPerc = ((Number(item.status[g].profitFx) * 100) / Number(item.status[g].amountFx)).toFixed(2)
                            }
                        }
                    }
                    //precios en vivo

                    const isFirstRow = g === 0;
                    let amountUsd = Number(item.status[g].amountUsd).toFixed(2).toString().replace(/\./g, ',');
                    let valueSplit = amountUsd.split(',');
                    if (valueSplit.length > 1) {
                        amountUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                    } else {
                        amountUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                    }

                    let fxPriceUsd = '0,00';
                    if (item.status[g].fxPriceUsd) {
                        fxPriceUsd = Number(item.status[g].fxPriceUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = fxPriceUsd.split(',');
                        if (valueSplit.length > 1) {
                            fxPriceUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            fxPriceUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let qty = '0,00';
                    if (item.status[g].qty) {
                        qty = Number(item.status[g].qty.toString()).toFixed(2).replace(/\./g, ',');
                        valueSplit = qty.split(',');
                        if (valueSplit.length > 1) {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            qty = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let costUsd = '0,00';
                    if (item.status[g].costUsd) {
                        costUsd = Number(item.status[g].costUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = costUsd.split(',');
                        if (valueSplit.length > 1) {
                            costUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            costUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    let weightPerc = '0,00';
                    if (item.status[g].weightPerc) {
                        weightPerc = Number(item.status[g].weightPerc).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = weightPerc.split(',');
                        if (valueSplit.length > 1) {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            weightPerc = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }


                    let profitUsd = '0,00';
                    if (item.status[g].profitUsd) {
                        profitUsd = Number(item.status[g].profitUsd).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = profitUsd.split(',');
                        if (valueSplit.length > 1) {
                            profitUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            profitUsd = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }
                    }

                    if (item.subtotal !== subtotal && subtotal !== null) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostMepFlag = Number(subtotalCostMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostMepFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>

                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalCostMep) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostMepFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                        subtotalAmount = Number(item.status[g].amountUsd ? item.status[g].amountUsd : 0);
                        subtotalCostMep = Number(item.status[g].costUsd ? item.status[g].costUsd : 0);
                        resultadoTotal = Number(item.status[g].profitUsd ? item.status[g].profitUsd : 0);
                    } else {
                        let validate = false;
                        for (let a1 = 0; a1 < item.status.length; a1++) {
                            if (item.status[a1].status === 'Total') {
                                validate = true;
                            }
                        }

                        if (validate === true && item.status[g].status === 'Total') {
                            subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountUsd : 0);
                            subtotalCostMep = Number(subtotalCostMep) + Number(item.status[g].costFx ? item.status[g].costUsd : 0);
                            resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitUsd : 0);

                        } else {
                            if (validate === false && item.status[g].status !== 'Total') {
                                subtotalAmount = Number(subtotalAmount) + Number(item.status[g].amountFx ? item.status[g].amountUsd : 0);
                                subtotalCostMep = Number(subtotalCostMep) + Number(item.status[g].costFx ? item.status[g].costUsd : 0);
                                resultadoTotal = Number(resultadoTotal) + Number(item.status[g].profitFx ? item.status[g].profitUsd : 0);
                            }
                        }
                    }

                    response.push(<TableRow sx={getRowStyle(false, rowIndex)}>
                        <TableCell sx={{
                            position: 'sticky',
                            left: 0,
                            backgroundColor: 'white',
                            zIndex: 3,
                            minWidth: 180
                        }} style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {isFirstRow && (
                                <Box display="flex" alignItems="center">
                                    <IconButton size="small" onClick={() => toggleItemUSD(item.itemId)}>
                                        {isItemExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                    <span style={{ fontWeight: 'bold' }}>{item.item}</span>
                                </Box>
                            )}
                        </TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {isFirstRow && (<>{item.symbol}</>)}</TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {isFirstRow && (<>{item.isin}</>)}</TableCell>
                        <TableCell style={{
                            fontSize,
                            padding: cellPadding
                        }}>
                            {item.status[g].status}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].qty) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{qty}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: (isPrecioEnVivo === true ? "#323B98" : (Number(item.status[g].fxPriceUsd) < 0 ? "red" : "black")), fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{fxPriceUsd} {isFactor}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].amountUsd) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{amountUsd}</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].weightPerc) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{weightPerc}%</TableCell>
                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].costUsd) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{costUsd}</TableCell>
                        <TableCell style={{ letterSpacing: "0.01rem" }} align="right">
                            {item.status.length === 1 ? (
                                <>
                                    {(Number(item.status[g].profitUsdPerc) * 100).toFixed(2)}%
                                    {Number(item.status[g].profitUsdPerc) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitUsdPerc) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : <ArrowRight
                                        style={{ color: "gray", fontSize: "1rem", marginLeft: 4 }}
                                    />}
                                </>
                            ) : item.status.length > 1 && item.status[g].status === "Total" ? (
                                <>
                                    {(Number(item.status[1].profitUsdPerc) * 100).toFixed(2)}%
                                    {Number(item.status[g].profitUsdPerc) > 0 ? (
                                        <ArrowUpward
                                            style={{ color: "green", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : Number(item.status[g].profitUsdPerc) < 0 ? (
                                        <ArrowDownward
                                            style={{ color: "red", fontSize: "1rem", marginLeft: 4 }}
                                        />
                                    ) : <ArrowRight
                                        style={{ color: "gray", fontSize: "1rem", marginLeft: 4 }}
                                    />}
                                </>
                            ) : null}
                        </TableCell>

                        <TableCell style={{
                            fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].profitUsd) < 0 ? "red" : "black", fontSize,
                            padding: cellPadding,
                            lineHeight: isPdf ? 1.2 : "normal"
                        }} align='right'>{profitUsd}</TableCell>
                    </TableRow>
                    );
                    rowIndex++;
                    subtotal = item.subtotal;

                    if (index === entityHoldingUSD.length - 1) {

                        let subtotalAmountFlag = Number(subtotalAmount).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalAmountFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalAmountFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let subtotalCostMepFlag = Number(subtotalCostMep).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = subtotalCostMepFlag.split(',');
                        if (valueSplit.length > 1) {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            subtotalCostMepFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        let resultadoTotalFlag = Number(resultadoTotal).toFixed(2).toString().replace(/\./g, ',');
                        valueSplit = resultadoTotalFlag.split(',');
                        if (valueSplit.length > 1) {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')},${valueSplit[1].slice(0, 2)}`;
                        } else {
                            resultadoTotalFlag = `${Number(valueSplit[0]).toLocaleString('es-AR')}`;
                        }

                        response.push(<TableRow sx={getRowStyle(true, rowIndex)}>
                            <TableCell sx={{
                                position: 'sticky',
                                left: 0,
                                backgroundColor: 'white',
                                zIndex: 3,
                                minWidth: 180
                            }} style={{
                                fontWeight: 'bold',
                                fontSize,
                                padding: cellPadding
                            }}>Subtotal {subtotal}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>

                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(item.status[g].subtotalAmount) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalAmountFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(subtotalCostMep) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{subtotalCostMepFlag}</TableCell>
                            <TableCell></TableCell>
                            <TableCell style={{
                                fontVariantNumeric: 'tabular-nums', letterSpacing: "0.01rem", color: Number(resultadoTotal) < 0 ? "red" : "black", fontSize,
                                padding: cellPadding,
                                lineHeight: isPdf ? 1.2 : "normal"
                            }} align='right'>{resultadoTotalFlag}</TableCell>
                        </TableRow>)
                        rowIndex++;
                    }
                });
        })

        return response;
    };

    const totalImporteFinal = subtotalesCards.reduce(
        (sum, card) => sum + Number(card.importe), 0
    );

    const totalImporteFinalUSD = subtotalesCardsUSD.reduce(
        (sum, card) => sum + Number(card.importe), 0
    );

    const handleChangeHomeTrade = (homeTrade) => {
        setHomeTrade(homeTrade);
    }

    const getRowStyle = (isSubtotal, rowIndex) => {
        let baseColor = "white";

        if (isSubtotal) {
            baseColor = "rgba(0, 0, 0, 0.04)";
        } else {
            baseColor = rowIndex % 2 === 0 ? "white" : "rgba(0, 0, 0, 0.02)";
        }

        return {
            backgroundColor: baseColor,
            "&:hover": {
                backgroundColor: "#e6ffff", // color al pasar con el mouse
            },
        };
    };

    const setViewPerformance = (item, homeTrade, mode = "ui") => {

        const isPdf = mode === "pdf";
        const fontSize = isPdf ? "8px" : "inherit";
        const cellPadding = isPdf ? "4px" : undefined;

        let endFx = homeTrade === 'ars' ? (item.endFx !== null && item.endFx !== undefined) ? Number(item.endFx).toFixed(0) : '' : (item.endUsd !== null && item.endUsd !== undefined) ? Number(item.endUsd).toFixed(0) : '';
        let netFx = homeTrade === 'ars' ? (item.netFx !== null && item.netFx !== undefined) ? Number(item.netFx).toFixed(0) : '' : (item.netUsd !== null && item.netUsd !== undefined) ? Number(item.netUsd).toFixed(0) : '';
        let changeFx = homeTrade === 'ars' ? (item.changeFx !== null && item.changeFx !== undefined) ? Number(item.changeFx).toFixed(0) : '' : (item.changeUsd !== null && item.changeUsd !== undefined) ? Number(item.changeUsd).toFixed(0) : '';
        let pctFx = homeTrade === 'ars' ? (item.pctFx !== null && item.pctFx !== undefined) ? Number(item.pctFx) * 100 : '' : (item.pctUsd !== null && item.pctUsd !== undefined) ? Number(item.pctUsd) * 100 : '';
        let inicio = (item.periodStart !== null && item.periodStart !== undefined) ? `${item.periodStart.split('-')[2]}/${item.periodStart.split('-')[1]}/${item.periodStart.split('-')[0].substring(2, 4)}` : '';
        let fin = (item.periodEnd !== null && item.periodEnd !== undefined) ? `${item.periodEnd.split('-')[2]}/${item.periodEnd.split('-')[1]}/${item.periodEnd.split('-')[0].substring(2, 4)}` : '';

        let responseView = [];
        responseView.push(
            <TableRow >
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontSize,
                    padding: cellPadding
                }}>{item.period}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontSize,
                    padding: cellPadding
                }}>{inicio}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontSize,
                    padding: cellPadding
                }}>{fin}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(endFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{endFx}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(netFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{netFx}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(changeFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{changeFx}</TableCell>
                <TableCell style={{
                    fontWeight: item.period === 'Total' ? 'bold' : 'normal',
                    fontVariantNumeric: 'tabular-nums',
                    letterSpacing: "0.01rem",
                    color: Number(pctFx) < 0 ? "red" : "black",
                    fontSize,
                    padding: cellPadding,
                    lineHeight: isPdf ? 1.2 : "normal"
                }}
                    align='right'
                >{pctFx}</TableCell>
            </TableRow>
        )
        return responseView;
    }

    return (

        <>
            <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
                <div style={{ overflowX: 'hidden' }}>
                    <MenuApp />
                    <Box border={1} marginTop="4rem" borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                        <Box display="flex" alignItems="center" gap={1}>


                            <ThemeProvider theme={constantsDesign.CUSTOM_MUI_BUTTON_THEME}>

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" }, // columna en mobile, fila en grande
                                        gap: 1
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: 1
                                        }}
                                    >
                                        <BusinessCenterOutlined fontSize="large" />

                                        <Button
                                            color="primary"
                                            variant={homeTrade === 'ars' ? 'contained' : 'outlined'}
                                            sx={{ height: 32, minWidth: 50 }}
                                            onClick={() => handleChangeHomeTrade('ars')}
                                        >
                                            ARS
                                        </Button>

                                        <Button
                                            color="primary"
                                            variant={homeTrade !== 'ars' ? 'contained' : 'outlined'}
                                            sx={{ height: 32, minWidth: 50 }}
                                            onClick={() => handleChangeHomeTrade('usd')}
                                        >
                                            USD
                                        </Button>

                                        <DateComponent
                                            disabled={false}
                                            id="filterDate"
                                            name="Desde"
                                            value={filterDate}
                                            onChange={(newDate) => handleFieldChange({ target: { value: newDate } })}
                                            help={null}
                                            mode="c"
                                            design={null}
                                            view={null}
                                        />

                                        <DateComponent
                                            disabled={false}
                                            id="filterDate"
                                            name="Hasta"
                                            value={filterDateHasta}
                                            onChange={(newDate) => handleFieldChangeHasta({ target: { value: newDate } })}
                                            help={null}
                                            mode="c"
                                            design={null}
                                            view={null}
                                        />

                                        <Button
                                            variant="text"
                                            size="small"
                                            //onClick={updatePrice}
                                            style={{ fontSize: "inherit", lineHeight: "inherit", color: 'black', textDecoration: "underline" }}
                                        >
                                            <RefreshIcon />
                                        </Button>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" }, // apila en mobile, fila en grande
                                            gap: 1,
                                            flex: 1
                                        }}
                                    >
                                        {viewComitente && (
                                            <>
                                                <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                                    {loadSubtotalesCards && (
                                                        <Autocomplete
                                                            options={optionsComitentes}
                                                            getOptionLabel={(option) => option.label}
                                                            value={filterComitente}
                                                            onChange={handleChange}
                                                            inputValue={inputValue}
                                                            onInputChange={handleInputChange}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                            disabled={(user.data.managerId && user.data.tradeAccountId) ? true : false}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Cuenta Comitente"
                                                                    variant="outlined"
                                                                    sx={{
                                                                        '& .MuiInputBase-root': {
                                                                            height: 32,
                                                                            minHeight: 32,
                                                                            paddingRight: '8px',
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            lineHeight: "inherit"
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '0 8px',
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            lineHeight: "inherit"
                                                                        },
                                                                        '& .MuiInputLabel-root': {
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            top: '-4px',
                                                                        },

                                                                        '& .MuiInputLabel-shrink': {
                                                                            transform: 'translate(14px, -3px) scale(0.58)',
                                                                        },
                                                                        '& .MuiOutlinedInput-notchedOutline legend': {
                                                                            maxWidth: 0,
                                                                        },
                                                                        '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                            maxWidth: 2500,
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                            fullWidth
                                                            slotProps={{
                                                                popper: {
                                                                    sx: {
                                                                        '& .MuiAutocomplete-option': {
                                                                            fontSize: 'inherit'
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </>
                                        )}
                                        {viewManager && (
                                            <>
                                                <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1 }}>
                                                    {loadSubtotalesCards && (
                                                        <Autocomplete
                                                            options={optionsManager}
                                                            getOptionLabel={(option) => option.label}
                                                            value={filterManager}
                                                            onChange={handleChangeManager}
                                                            inputValue={inputValueManager}
                                                            onInputChange={handleInputChangeManager}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                            disabled={(user.data.managerId && !user.data.tradeAccountId) ? true : false}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Agente Productor"
                                                                    variant="outlined"
                                                                    sx={{
                                                                        '& .MuiInputBase-root': {
                                                                            height: 32,
                                                                            minHeight: 32,
                                                                            paddingRight: '8px',
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            lineHeight: "inherit"
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '0 8px',
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            lineHeight: "inherit"
                                                                        },
                                                                        '& .MuiInputLabel-root': {
                                                                            fontSize: "inherit",
                                                                            fontWeight: '600',
                                                                            top: '-4px',
                                                                        },
                                                                        '& .MuiInputLabel-shrink': {
                                                                            transform: 'translate(14px, -3px) scale(0.58)',
                                                                        },
                                                                        '& .MuiOutlinedInput-notchedOutline legend': {
                                                                            maxWidth: 0,
                                                                        },
                                                                        '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                                            maxWidth: 2500,
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                            fullWidth
                                                        />
                                                    )}
                                                </Box>
                                            </>
                                        )}
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" },
                                            gap: 1,
                                            flex: 1
                                        }}
                                    >


                                        {loadSubtotalesCards &&
                                            (subtotalesCardsUSD.length > 0 || subtotalesCards.length > 0) && (

                                                <BlobProvider
                                                    document={
                                                        <VistaPdfExport
                                                            homeTrade={homeTrade}
                                                            portafolioTotal={portafolioTotal}
                                                            portafolioDisponible={portafolioDisponible}
                                                            portafolioGarantia={portafolioGarantia}
                                                            portafolioTotalUSD={portafolioTotalUSD}
                                                            portafolioDisponibleUSD={portafolioDisponibleUSD}
                                                            portafolioGarantiaUSD={portafolioGarantiaUSD}
                                                            entityBalance={entityBalance}
                                                            entityBalanceUSD={entityBalanceUSD}
                                                            entityHolding={entityHolding}
                                                            entityHoldingUSD={entityHoldingUSD}
                                                            subtotalesCards={subtotalesCards}
                                                            subtotalesCardsUSD={subtotalesCardsUSD}
                                                            totalSubTotal={totalSubTotal}
                                                            totalSubTotalUSD={totalSubTotalUSD}
                                                            backgroundColor={backgroundColor}
                                                            DoughnutComponent={Doughnut}
                                                            tipoCambio={tipoCambio}
                                                            tipoCambioCcl={tipoCambioCcl}
                                                            amountCtaCte={amountCtaCte}
                                                            amountCtaCteUSD={amountCtaCteUSD}
                                                            setViewEntityBalance={setViewEntityBalance}
                                                            setViewEntityBalanceUSD={setViewEntityBalanceUSD}
                                                            setViewEntitHolding={setViewEntitHolding}
                                                            setViewEntitHoldingMEP={setViewEntitHoldingMEP}
                                                            filterManager={filterManager}
                                                            viewManager={viewManager}
                                                            viewComitente={viewComitente}
                                                            filterComitente={filterComitente}
                                                            filterDate={filterDate}
                                                        />
                                                    }
                                                >
                                                    {({ blob, loading }) => {

                                                        if (loading) {
                                                            return <span></span>;
                                                        }

                                                        return (
                                                            <PictureAsPdfIcon
                                                                fontSize="large"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={async () => {

                                                                    try {

                                                                        const formData = new FormData();
                                                                        formData.append("file", blob, "position.pdf");

                                                                        const response = await informationService.pdfprotect(formData);

                                                                        const protectedBlob = response.data;

                                                                        const url = window.URL.createObjectURL(protectedBlob);

                                                                        const a = document.createElement("a");

                                                                        const moneda = homeTrade?.toUpperCase();
                                                                        const fecha = filterDate
                                                                            ? `${filterDate.split('-')[2]}${filterDate.split('-')[1]}${filterDate.split('-')[0].substring(2, 4)}`
                                                                            : null;

                                                                        const comitente = filterComitente?.id;

                                                                        const agenteProductor = filterManager?.id;

                                                                        const partesNombre = [
                                                                            "Posición",
                                                                            moneda,
                                                                            fecha,
                                                                            comitente,
                                                                            agenteProductor
                                                                        ].filter(value => value !== null && value !== undefined && value !== "");

                                                                        a.href = url;
                                                                        a.download = `${partesNombre.join("_")}.pdf`;

                                                                        document.body.appendChild(a);

                                                                        a.click();

                                                                        a.remove();

                                                                        window.URL.revokeObjectURL(url);

                                                                    } catch (e) {
                                                                        console.error(e);
                                                                    }

                                                                }}
                                                            />
                                                        );
                                                    }}
                                                </BlobProvider>
                                            )}


                                    </Box>
                                </Box>
                            </ThemeProvider>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' }, // responsive: en mobile apila
                                justifyContent: 'space-between',             // separa gráfico y tabla
                                alignItems: 'flex-start',                    // alinea arriba
                                gap: 4,                                       // espacio entre ambos
                                width: '100%',
                                marginTop: '20px'
                            }}
                        >

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' }, // Responsive
                                    gap: 2,
                                    flex: 1,
                                }}
                            >

                                {/*<Box sx={{ width: 250, height: 350, mx: 'auto' }}>
                                    <BarChart
                                        subtotalesCards={[
                                            { subtotal: 'ACCIONES', importe: '1500000' },
                                            { subtotal: 'BONOS', importe: '2500000' },
                                            { subtotal: 'FCI', importe: '900000' },
                                        ]}
                                    />
                                </Box>*/}
                            </Box>
                        </Box>
                    </Box>

                    <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>
                        <TableContainer component={Paper} sx={{
                            overflowX: 'auto',
                            overflowY: 'auto'
                        }}/*sx={{ maxHeight: '500px', overflowY: 'auto' }}*/>
                            <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">
                                <TableHead>
                                    <TableRow sx={{ position: 'sticky', top: 0, zIndex: 5, backgroundColor: 'rgb(50 59 152)' }}>
                                        <TableCell
                                            sx={{
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 6,
                                                backgroundColor: 'rgb(50 59 152)',
                                                color: 'white',
                                                minWidth: 180
                                            }}
                                        >
                                            Periodo
                                        </TableCell>
                                        <TableCell style={{ color: 'white' }}>Inicio</TableCell>
                                        <TableCell style={{ color: 'white' }}>Fin</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Posición ({homeTrade.toUpperCase()})</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Contribución ({homeTrade.toUpperCase()})</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Cambio ({homeTrade.toUpperCase()})</TableCell>
                                        <TableCell style={{ color: 'white', textAlign: 'center' }}>Portfolio (%)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        performanceReponse.map((item, index) => {
                                            return setViewPerformance(item, homeTrade);
                                        })
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div >
            </ThemeProvider >


        </>
    )
}

export default Performance